import { render } from "./BaseRouterLinkButton.vue?vue&type=template&id=13046aa1"
import script from "./BaseRouterLinkButton.vue?vue&type=script&lang=js"
export * from "./BaseRouterLinkButton.vue?vue&type=script&lang=js"
script.render = render

export default script